import { getLocalStorageItem, removeLocalStorageItem, getFingerprintHash } from '@fastcampus/browser-util';

const getSignInUrl = ({ authUrl, option, dest = '/authorize' }) => {
  return getFingerprintHash().then((fingerprint) => {
    const params = new URLSearchParams({ ...option, 'x-fingerprint': fingerprint });

    return `${authUrl}${dest}?${params}`;
  });
};

const getSignOutUrl = ({ authUrl, returnTo }) => {
  return `${authUrl}/signout?returnUrl=${window.location.origin}${returnTo}`;
};

/**
 * @function
 * @name signIn
 * @param {object} object
 * @param {string} object.tokenKey
 * @param {string} object.authUrl
 * @param {object} object.option
 * @param {string} object.option.client_id
 * @param {string} object.option.response_type
 * @param {string} object.option.redirect_uri
 * @param {string} [object.option.scope]
 */

export const signIn = ({ tokenKey, authUrl, option, isHistoryReplaceRequired, dest }) => {
  removeLocalStorageItem(tokenKey);
  getSignInUrl({ authUrl, option, dest }).then((signinUrl) => {
    if (isHistoryReplaceRequired) {
      window.location.replace(signinUrl);
    } else {
      window.location.href = signinUrl;
    }
  });
};

/**
 * @function
 * @name signOut
 * @param {object} object
 * @param {string} object.tokenKey
 * @param {string} object.authUrl
 * @param {string} object.returnTo
 */
export const signOut = ({ tokenKey, authUrl, returnTo = '', isHistoryReplaceRequired }) => {
  removeLocalStorageItem(tokenKey);
  const signoutUrl = getSignOutUrl({ authUrl, returnTo });
  if (isHistoryReplaceRequired) {
    window.location.replace(signoutUrl);
  } else {
    window.location.href = signoutUrl;
  }
};

const checkTokenInHash = () => {
  const params = new URLSearchParams(window.location.hash.substring(1));
  const error = params.get('error');
  if (error === 'access_denied') {
    throw new Error('access_denied');
  } else if (error === 'organization_domain_not_found'.toUpperCase()) {
    throw new Error('organization_domain_not_found'.toUpperCase());
  } else if (error === 'organization_domain_not_allowed'.toUpperCase()) {
    throw new Error('organization_domain_not_allowed'.toUpperCase());
  }

  const accessToken = params.get('access_token');
  if (!accessToken) {
    throw new Error('no_token');
  }
  return accessToken;
};

const checkTokenInLocal = (tokenKey) => {
  const token = getLocalStorageItem(tokenKey);
  if (token) {
    return token;
  }
  throw new Error('no_token');
};

/**
 * @function
 * @name checkToken
 * @param {string} tokenKey
 */
export const checkToken = (tokenKey) => {
  try {
    return checkTokenInHash();
  } catch (err) {
    if (err.message === 'no_token') return checkTokenInLocal(tokenKey);
    throw err;
  }
};
